// extracted by mini-css-extract-plugin
export default {"DraggableButton":"zt8Yjsqe"};